import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  EMPTY_LIST,
  EMPTY_STRING,
} from '../../../../../../../../constants/common'
import {
  isEventKeyEnter,
  preventDefault,
  stopPropagation,
} from '../../../../../../../../utils/events'
import { useInitiallyOpenSelect } from '../../../../../../../Select'
import {
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT,
  REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
} from '../../../../RequestProfileWidgetSideWorkers.constants'
import { REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_INVALID_EMAIL_KEY } from '../../../RequestProfileWidgetSideWorkersForm.constants'
import { isRequestProfileWidgetSideWorkersValid } from '../../../RequestProfileWidgetSideWorkersForm.utils'

import { getSideWorkerSelectItemByEmail } from './useSideWorkersFieldHandlers.utils'

export function useSideWorkersFieldHandlers() {
  const { t } = useTranslation()

  const { setFieldError, setFieldTouched, setFieldValue, values } =
    useFormikContext()

  const sideWorkerSelectStatesRef = useInitiallyOpenSelect(
    values[REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS]
      .length === 0
  )

  function resetSideWorkersInputError() {
    setFieldValue(
      REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT,
      false
    )
    setFieldError(
      REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
      undefined
    )
  }

  function handleChangeSideWorkers(nextValue) {
    if (isRequestProfileWidgetSideWorkersValid(nextValue)) {
      resetSideWorkersInputError()
    }
  }

  function handleSideWorkerSelectClose() {
    const searchValue =
      sideWorkerSelectStatesRef.current?.searchValue?.trim() || EMPTY_STRING

    if (searchValue) {
      const currentWorkers =
        values[REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS]

      const alreadyExists = currentWorkers.some(
        item => item.email === searchValue
      )

      if (alreadyExists) {
        sideWorkerSelectStatesRef.current?.handleClearSearch?.()
      } else {
        const workerByEmail = getSideWorkerSelectItemByEmail(searchValue)
        const nextWorkers = [...currentWorkers, workerByEmail]

        if (isRequestProfileWidgetSideWorkersValid(nextWorkers)) {
          setFieldValue(
            REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
            nextWorkers
          )
          setFieldTouched(
            REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
            true
          )
          resetSideWorkersInputError()
          sideWorkerSelectStatesRef.current?.handleClearSearch?.()
        } else {
          setFieldTouched(
            REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
            true
          )
          setFieldValue(
            REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT,
            true
          )
          setFieldError(
            REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS,
            t(REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FORM_INVALID_EMAIL_KEY)
          )
        }
      }
    } else {
      resetSideWorkersInputError()
    }
  }

  function handleInputKeyDown(event) {
    if (isEventKeyEnter(event)) {
      preventDefault(event)
      stopPropagation(event)

      const options = sideWorkerSelectStatesRef.current?.options || EMPTY_LIST

      if (options.length === 0) {
        sideWorkerSelectStatesRef.current?.handleClose?.()
      }
    }
  }

  return {
    handleChangeSideWorkers,
    handleInputKeyDown,
    handleSideWorkerSelectClose,
    sideWorkerSelectStatesRef,
  }
}
